export default __webpack_public_path__ + "static/media/logo.a87165b0.svg";